import React from 'react';

interface State { hasError: boolean; message?: string }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(err: unknown): State {
    return { hasError: true, message: err instanceof Error ? err.message : String(err) };
  }

  componentDidCatch(err: unknown, info: unknown) {
    console.error('[practice-iq] Unhandled error in task pane:', err, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16, fontFamily: '"Segoe UI", Arial, sans-serif', fontSize: 14, color: '#1f1f1f' }}>
          <h2 style={{ margin: '0 0 8px 0', fontSize: 18 }}>Practice IQ — something went wrong</h2>
          <p>The task pane hit an unexpected error and had to recover. Your workbook is untouched.</p>
          <pre style={{
            background: '#fde7e9', border: '1px solid #d13438', color: '#a4262c',
            padding: 10, borderRadius: 4, fontSize: 12, whiteSpace: 'pre-wrap', margin: '8px 0',
          }}>{this.state.message ?? 'Unknown error'}</pre>
          <button
            onClick={() => this.setState({ hasError: false, message: undefined })}
            style={{
              padding: '8px 14px', fontSize: 13, fontWeight: 600,
              color: '#fff', background: '#0078d4', border: 'none',
              borderRadius: 4, cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
